/* eslint-disable jsx-a11y/alt-text */

import { useEffect, useRef, useState } from "react";
import JSZip from "jszip";
import styles from "../styles/components/PromptInputs.module.css";
import common from "../styles/Common.module.css";
import { AnimationListExtended } from "./AnimationList";
import useApi from "../hooks/useApi";
import clearIcon from "../images/clear.svg";
import downloadIcon from "../images/download.svg";

const DatasetCreator = ({ dataset, startRecording, clearDataset, animations, recording, updateTriggerWord, triggerWordError }) => {

	const { postFile } = useApi();

	const [triggerWord, setTriggerWord] = useState("");
	  

	const initialAnimations = animations.map(({id, name, fbx}) => {
		return {
			id, fbx, name,
			selected: true, 
		}
	});
	
	const [selectedAnimations, setSelectedAnimations] = useState(initialAnimations);
	
	// Function to convert dataURL to Blob
    function dataURLToBlob(dataURL) {
		const [header, base64] = dataURL.split(',');
		const binary = atob(base64);
		const array = new Uint8Array(binary.length);
		for (let i = 0; i < binary.length; i++) {
			array[i] = binary.charCodeAt(i);
		}
		const mime = header.match(/:(.*?);/)[1];
		return new Blob([array], { type: mime });
	}

	// Create a ZIP file from dataURLs
	async function createZip(dataURLs) {
		const zip = new JSZip();

		// Add each image to the ZIP
		dataURLs.forEach((dataURL, index) => {
			const blob = dataURLToBlob(dataURL);
			zip.file(`image_${index + 1}.png`, blob);
		});

		// Generate the ZIP file as a Blob
		return zip.generateAsync({ type: "blob" });
	}

	// Download the ZIP file
	const downloadZip = (zipBlob) => {
		const url = URL.createObjectURL(zipBlob); // Create a temporary URL for the Blob
		const link = document.createElement("a");
		link.href = url;
		link.download = "images.zip"; // Set the default file name
		link.click(); // Programmatically click the link to start download
		URL.revokeObjectURL(url); // Clean up the URL after download
	};
	
	const downloadDataset = async () => {
		let ids = [];
		const zipBlob = await createZip(dataset.map((d) => {
			ids.push(d.animation.id);
			return d.dataURL;
		}));
		downloadZip(zipBlob);
	}
	const handleAnimationCheck = (index) => {
		const newAnimations = selectedAnimations.map((animation, anim_index) => {
			if(anim_index === index) return {...animation, selected: !animation.selected}
			return animation;
		});
		setSelectedAnimations(newAnimations);
	}

	const handleCheckAll = () => {
		setSelectedAnimations(initialAnimations);
	}
	const handleUncheckAll = () => {
		const newAnimations = selectedAnimations.map((animation, anim_index) => {
			return {...animation, selected: false}
		});
		setSelectedAnimations(newAnimations);
	}

	return (
		<>
			{recording &&
				<div className={styles.recordingLabel}>
					<p>Images are being captured. Please do not leave this screen.</p>
				</div>
			}
			{!recording &&
				<>
					{dataset.length > 0 &&
						<>
							<input placeholder="Trigger Word" className={triggerWordError ? styles.triggerWordInputError : styles.triggerWordInput} value={triggerWord} onChange={(e) => {
								setTriggerWord(e.target.value);
								updateTriggerWord(e.target.value);
							}}></input>
							<div className={styles.datasetContainer}>
								{ dataset.map(({animation, frame, dataURL}) => <div key={`${animation.id}_${frame}`} className={styles.datasetItem} >
									<img src={dataURL}></img>
								</div>) }
							</div>
						</>
					}

					{dataset.length === 0 &&
						<div className={styles.datasetContainer}>
							<div className={styles.trainButtonContainer}>
								<button className={styles.smallButton} onClick={handleCheckAll}>check all</button>
								<button className={styles.smallButton}onClick={handleUncheckAll}>un-check all</button>
							</div>
								
							<form>
						{ selectedAnimations.map(({id, name, selected}, index) => {
							
							return <div className={styles.datasetAnimation}  key={'ch_'+index}>
								{selected &&
									<input type="checkbox" checked name={name} onChange={() => handleAnimationCheck(index)}/>
								}
								{!selected &&
									<input type="checkbox" name={name} onChange={() => handleAnimationCheck(index)}/>
								}
								<label onClick={() => handleAnimationCheck(index)}>{name}</label>
							</div>
						})}
						</form>
						
						</div>
					}
					
					{dataset.length === 0 && 
					<div className={common.buttonBar}>
						<button
							className={common.generateButton}
							onClick={() => startRecording(selectedAnimations)}
						>
							Capture Dataset
						</button>			
					</div>
					}
					{dataset.length > 0 && 
						<div className={styles.datasetButtons}>
							<button onClick={downloadDataset} className={styles.downloadButton}>
								<img className={styles.downloadIcon} src={downloadIcon} />
								<p>download</p>
							</button>
							<button onClick={clearDataset} className={styles.clearButton}>
								<img className={styles.clearIcon} src={clearIcon} />
								<p>clear</p>
							</button>
						</div>
					}
				</>
			}

		</>
	);
};

export default DatasetCreator;
